import "./ForgotPassword.scss";
import React, { useContext, useEffect, useState } from "react";
import { Box, Card, Container, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import { GlobalContext } from "../../context/Provider";
import { envioMailReseteoContrasena } from "../../services/LoginService";

const ForgotPassword = () => {
  const [errorMessage, setErrorMessage] = useState("");

  const [showForm, setShowForm] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [values, setValues] = React.useState({
    showPassword: false,
  });
  const navigate = useNavigate();

  const {
    authDispatch,
    authState: {
      auth: { loading, error, data },
    },
  } = useContext(GlobalContext);

  useEffect(() => {
    if (data) {
      navigate("/home");
    }
  }, [data]);

  const handleClickRegister = () => {
    navigate("/register");
  };

  const handleClickLoginDoctor = () => {
    navigate("/");
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = (data) => {
    envioMailReseteoContrasena(data.email)
      .then((response) => {
        const { status, statusResult } = response;

        if (status === "Ok" || statusResult === 400) {
          setShowForm(!showForm);
          setShowConfirmation(!showConfirmation);
        }
      })
      .catch((error) => {
        console.error("Error en envioMailReseteoContrasena:", error);
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("El campo Email es requerido")
        .email("El formato del campo Email es incorrecto")
        .max(100, "El campo Email puede tener hasta 100 caracteres"),
    }),
    onSubmit: (data) => onSubmit(data),
  });
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        marginTop: 20,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ padding: "20px" }}>
          {/* Show Form */}
          {showForm && (
            <form onSubmit={formik.handleSubmit}>
              <Box sx={{ my: 1 }}>
                <Typography
                  color="textPrimary"
                  align="center"
                  variant="h4"
                >
                  ¿Olvidó su contraseña?
                </Typography>
                {error && (
                  <Typography
                    align="center"
                    sx={{
                      fontSize: "0.84rem",
                      lineHeight: "1.5rem",
                      fontWeight: "300",
                      color: "red",
                    }}
                  >
                    {error}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  Complete el correo electrónico para resetear su contraseña
                </Typography>
              </Box>
              <TextField
                error={Boolean(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label="Email"
                margin="normal"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="email"
                value={formik.values.email}
                variant="outlined"
              />

              {errorMessage && (
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    textAlign: "center",
                    color: "red",
                  }}
                >
                  {errorMessage}
                </Typography>
              )}

              <Box sx={{ mt: 2 }}>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Resetear contraseña
                </LoadingButton>
              </Box>
              <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                <a
                  href="/password-reset"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClickLoginDoctor();
                  }}
                  className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  style={{ marginBottom: "8px", textDecoration: "none" }}
                >
                  Ingreso a la plataforma
                </a>
              </Box>
              <Box sx={{ mt: 0, display: "flex", justifyContent: "flex-end" }}>
                <a
                  href="/register"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClickRegister();
                  }}
                  className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  style={{ textDecoration: "none" }}
                >
                  Registro de usuario
                </a>
              </Box>
            </form>
          )}

          {/* Show Confirmation */}
          {showConfirmation && (
            <form>
              <Box sx={{ my: 1 }}>
                <Typography
                  color="textPrimary"
                  align="center"
                  variant="h4"
                >
                  Verifique su correo electrónico
                </Typography>
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  Recibirás un email al correo electrónico que ingresaste, en caso de estar registrado, para que puedas restablecer tu contraseña. Si no recibes el email en los próximos minutos, por favor verifica en tu bandeja de SPAM.
                </Typography>
              </Box>
            </form>
          )}
        </Card>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
